import { render } from "./saleCRUD.vue?vue&type=template&id=3184ea96&scoped=true"
import script from "./saleCRUD.vue?vue&type=script&lang=js"
export * from "./saleCRUD.vue?vue&type=script&lang=js"

import "./saleCRUD.vue?vue&type=style&index=0&id=3184ea96&scoped=true&lang=scss"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3184ea96"]])

export default __exports__